import React, { PureComponent } from 'react'
import { string } from 'prop-types'
import StreetViewImage from './StreetViewImage'
import AddressContainer from './AddressContainer'
import OptionsButtons from './OptionsButtons'
import SubTypeChart from './SubTypeChart'
import SubTypeMenu from './SubTypeMenu'
import SmallMap from './SmallMap'
import Downloads from './Downloads'
import SubTypeLegends from './SubTypeLegends'
import Disclaimer from './Disclaimer'
import { Segment } from 'semantic-ui-react'

const DisclaimerWithProps = () => (
  <Disclaimer
    mainClassName="disclaimer"
    headingClassName="disclaimer-heading"
  />
)

class SearchContentContainer extends PureComponent {
  render() {
    return (
      <div className={`search-content animated ${this.props.animationClass} `}>
        <Segment.Group style={{ paddingRight: '2px', borderTop: 'none' }}>
          <Segment as={StreetViewImage} />
          <Segment as={AddressContainer} />
          <Segment as={OptionsButtons} />
          <Segment as={SmallMap} />
          <Segment as={SubTypeChart} />
          <Segment as={SubTypeLegends} />
          <Segment as={DisclaimerWithProps} />
        </Segment.Group>
        <Downloads />
        <SubTypeMenu />
      </div>
    )
  }
}

SearchContentContainer.propTypes = {
  animationClass: string.isRequired,
}

export default SearchContentContainer



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SearchContentContainer.jsx